import React from "react";

const style = {
    fontSize:"25px",
    color:"#000",
    textTransform:"upperCase"
}

const Heading=({title,className,orangeheading,content,...restProps})=>{
    return(
         <>
           <h3 style={style} className={className} {...restProps} >
            <span style={{color:"#c82e21"}}>{orangeheading}</span> {title}
            <div dangerouslySetInnerHTML={{ __html: content }} />
            </h3>
         </>
    )
}
export {Heading};

